import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgArrowLeft = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.74231 9.95633H20V12.0437L5.74231 12.0437L9.93864 16.524L8.55624 18L2 11L8.55624 4L9.93864 5.47597L5.74231 9.95633Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgArrowLeft);

export default ForwardRef;
